<!-- <a *ngIf="linkType != linkTypes.None" [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" rel="noopener noreferrer" [routerLink]="['/communities/' + object.id]" class="lead">
    {{object.name}}
</a>
<span *ngIf="linkType == linkTypes.None" class="lead">
    {{object.name}}
</span>
<div *ngIf="object.shortDescription" class="text-muted abstract-text">
    {{object.shortDescription}}
</div> -->

<div class="card h-100 shadow-sm">
    <div class="card-body d-flex flex-column">
      <!-- Icon + Name -->
      <div class="d-flex align-items-center mb-2">
        <i class="bi bi-people-fill text-primary fs-3 me-2"></i>
  
        <h5 class="card-title mb-0">&nbsp;
          <a *ngIf="linkType != linkTypes.None"
             [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'"
             rel="noopener noreferrer"
             [routerLink]="['/communities/' + object.id]"
             class="stretched-link text-decoration-none">
            {{ object.name }}
          </a>
          <span *ngIf="linkType == linkTypes.None">
            {{ object.name }}
          </span>
        </h5>
      </div>
  
      <!-- Description -->
      <p *ngIf="object.shortDescription" class="card-text text-muted flex-grow-1">
        {{ object.shortDescription }}
      </p>
    </div>
  </div>
  
  